import * as THREE from "three";
//Light
const ambientalLight = new THREE.AmbientLight(0x252850,1);
const pointLight  = new THREE.PointLight(0x252850,7); 
pointLight.position.set(1,2,1);
export {ambientalLight,pointLight};